import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { IFaq } from '../types/generated'

/**
 * Fetch a single Faq from Contentful
 *
 * @param {string} id The ID of this Faq
 */
export const fetchFaq = async (id: string): Promise<IFaq | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'faq',
      'sys.id': id,
      include: 5,
    }),
  ) as IFaq | undefined
}

/**
 * Fetch all Faqs from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchFaqs = async (
  query?: Record<string, unknown>,
): Promise<IFaq[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      order: 'fields.title',
      ...query,
      content_type: 'faq',
    }),
  ) as IFaq[]
}
